import { render, staticRenderFns } from "./DistributionCenterConfigs.vue?vue&type=template&id=6aea1e85&scoped=true"
import script from "./DistributionCenterConfigs.vue?vue&type=script&lang=js"
export * from "./DistributionCenterConfigs.vue?vue&type=script&lang=js"
import style0 from "./DistributionCenterConfigs.vue?vue&type=style&index=0&id=6aea1e85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aea1e85",
  null
  
)

export default component.exports